import Breadcrumb from "../../components/Breadcrumb";
import DepartmentGallery from "../../components/DepartmentGallery";
import FeaturesTwo from "../../components/FeaturesTwo";
import { getDepartmentGalleryData } from "../../data/departmentGalleries";


const deptData = {
    mission: "To promote holistic community health through preventive care, education, research, and equitable healthcare delivery.",
    vision: "To build healthier communities by advancing public health practice, social responsibility, and evidence-based medicine.",
    title: "Community Medicine",
    para: "The Department of Community Medicine focuses on improving population health through disease prevention, health promotion, and primary health care. The department caters at community level through two health centers- Urban Health Training Centre at Tindivanam and Rural Health Training Centre at Mailam. Health needs of the population are measured and appropriate strategies are developed to improve the health status of the community.\n \nOur department is dedicated to training competent healthcare professionals who address community health needs through education, research, and active community engagement.The department provides early exposure of undergraduate students to community health care through Family Adoption Program.By integrating public health principles with real - world practice, we strive to promote equitable healthcare and sustainable health outcomes for all.The discipline bridges clinical medicine and public health by addressing social, behavioral, environmental, and economic determinants of health.It equips medical students with the skills to understand community disease patterns, plan and implement health interventions, evaluate health programs, and contribute to health policy."
}


const departmentDocuments = [
    {
        title: "Report on National Nutrition Week Celebration 2026",
        meta: "Department of Community Medicine, TMC TU",
        path: "/assets/document/department/community-medicine/report-on-national-nutrition-week-celebration.pdf",
    },
];

const CommunityMedicine = () => {

    const GalleryData = getDepartmentGalleryData("community_medicine");

    return (
        <>
            <Breadcrumb heading={true} title={"Department of Community Medicine"} />
            <FeaturesTwo data={deptData} />
            <DepartmentGallery title={deptData.title} GalleryData={GalleryData} />

            <section className="dept-reports py-120">
                <div className="container">
                    <div className="section-heading text-center">
                        <h2 className="mb-24">Department Reports</h2>
                    </div>

                    <div className="row gy-4 justify-content-center">
                        {departmentDocuments.map((doc) => (
                            <div className="col-lg-6" key={doc.path}>
                                <a
                                    href={`/view-document.html?file=${encodeURIComponent(doc.path)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="h-100 d-flex flex-column p-24 rounded-12 border border-neutral-30 bg-white text-decoration-none"
                                >
                                    <span className="w-48 h-48 rounded-circle bg-main-25 text-main-600 flex-center mb-16">
                                        <i className="ph ph-file-text" style={{ fontSize: "24px" }} />
                                    </span>
                                    <h5 className="mb-8 text-neutral-700">{doc.title}</h5>
                                    <p className="mb-16 text-neutral-500">{doc.meta}</p>
                                    <span className="flex-align gap-8 text-main-600 fw-semibold mt-auto">
                                        View Document
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default CommunityMedicine;
